import React from "react";
import CPaginator from "../CPaginator";
import './style.scss';

const alignment = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
}

export default ({ columns = [], data = [], currentPage = 0, perPage = 10, total = 10, onChangePage = () => {}, paginator, height = "40vh" }) => {

    if (!data?.length || !columns?.length) return null;

    return (
        <div className="c-table">
            <div className="c-table-head">
                <div className="c-table-row">
                    {columns.map(column => {
                        return (
                            <div
                                style={{
                                    minWidth: column.minWidth || 'none',
                                    width: column.width || 'none',
                                    maxWidth: column.width || 'none',
                                    justifyContent: alignment[column.align] || 'flex-start'
                                }}
                                key={String(column.field)}
                                className={`c-table-cell ${column.width ? 'c-table-cell-fixed-width' : ''}`}
                            >
                                <span>{column.displayName}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="c-table-body" style={{ maxHeight: height }}>
                {data.map((row, index) => {
                    return (
                        <div key={`row-${index}`} className="c-table-row">
                            {columns.map(column => {
                                return (
                                    <div
                                        className={`c-table-cell ${column.width ? 'c-table-cell-fixed-width' : ''}`}
                                        key={`cell-${String(column.field)}`}
                                        style={{
                                            minWidth: column.minWidth || 'none',
                                            width: column.width || 'none',
                                            maxWidth: column.width || 'none',
                                            justifyContent: alignment[column.align] || 'flex-start'
                                        }}>
                                        {column.render ? column.render(row) : String(row[column.field])}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
                {paginator && <div className="c-table-footer">
                    <CPaginator
                        currentPage={currentPage}
                        perPage={perPage}
                        total={total}
                        onChangePage={(page) => onChangePage(page)}
                    />
                </div>}
            </div>
        </div>
    )
}